module.exports = "/_next/static/images/santai-logo-b38cfa888476d10dad01fee0a933399c.png";